import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { PAGES } from '../constants';

export default function Footer({ fromPrivacy }) {
    const currentYear = useMemo(() => new Date().getFullYear());
    const navigation = useNavigate();

    const _handleNavigation = () => {
        if (fromPrivacy) {
            navigation(PAGES.INDEX);
        } else {
            navigation(PAGES.PRIVACY);
        }
    };

    return (
        <div className="h-20 bg-gray-100 flex items-center justify-between px-8 lg:px-28">
            <p className="text-gray-700 text-sm select-none">
                &copy; {currentYear} GitSetCode Software Solutions
            </p>

            <button
                onClick={_handleNavigation}
                className="text-gray-600 hover:text-primary-color transition-colors duration-300 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-primary-color rounded"
                aria-label={fromPrivacy ? 'Back to Home' : 'Privacy Policy'}
            >
                {fromPrivacy ? 'Back to Home' : 'Privacy Policy'}
            </button>
        </div>
    );
}
